import React, { useState } from "react";
import {
  IonRow,
  IonCol,
  IonRadioGroup,
  IonItem,
  IonRadio,
  IonLabel,
  IonItemDivider
} from "@ionic/react";
import "./Preferences.scss";
import { useTranslation } from "react-i18next";
import { PREFERENCE_DATA } from "../../../utils/constants";
import { isMobile } from "../../../utils/common";
import { CustomModalWeb } from "../userProfile/CustomModalWeb";
import { PreferenceCapacityValueChange, PreferenceViewValidation } from "./PreferencesUtil";
import { useSelector, useDispatch } from "react-redux";
import { UpdatePreferences } from "../../../actions/App/action";
import { CustomModal } from "../../../components/CustomModal";

export const Preferences_CapacityTypePopUp: React.FC<any> = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const UserPreferencesDomain = useSelector(
    (state: any) => state && state.global && state.global.userPreferencesDomain
  );
  const [capacityTypeData] = useState<any>(
    PREFERENCE_DATA.filter(
      (item: any) => item.ACCORD_ROLE_FILTER_KEY === "CAPACITY_TYPE"
    )[0].ACORD_CONTENT[0]
  );
  const Preferences_CapacityTypeModalProps = {
    isModalOpen: props.isOpen,
    title: t("Capacity Type"),
    contentAlignment: "left",
    aditionalCssClass: "Preferences_CapacityTypeModal",
    size: "large_width extra_small_height",
    contentScroll: "deny",
    backdropDismiss: true
  };
  const Preferences_CapacityTypeModalPropsMobile = {
    isOpen: props.isOpen,    
    title: t("Capacity Type"),
    size:"extra-large",
    aditionalCssClass: "Preferences_CapacityTypeModal_backdrop",
    modalFade:true
  };
  const handleChange = (e: any) => {
    let payload = {
      domain: UserPreferencesDomain || "carrier",
      updatePreferences: [
        { key: "preferredcapacitytype", value: e.target.name }
      ]
    };
    dispatch(UpdatePreferences(payload));
    props.closeModal(PreferenceCapacityValueChange(e?.target?.name));
  };
  return (
    <>
      {isMobile ? (
        <CustomModal {...Preferences_CapacityTypeModalPropsMobile}>
          <div className="Preferences_CapacityTypeModal ion-text-start">
            <IonRow className="ion-margin-start">
              <IonCol>{capacityTypeData.CONTENT_TITLE}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol className={isMobile ? "" : "radio-group"}>
                {capacityTypeData.CONTENT_VALUE.map((option: any, index: any) =>
                  PreferenceViewValidation("CAPACITY_TYPE") ? (
                    <div key={option.OPTION_TITLE}>
                      <IonRadioGroup
                        onIonChange={handleChange}
                        name={option.OPTION_VALUE}
                        value={"test"}
                      >
                        <IonItem key={option.OPTION_TITLE}>
                          <IonRadio
                            value={option.OPTION_VALUE}
                            name={capacityTypeData.API_KEY}
                            class="radiobutton"
                            mode="md"
                          />
                          <IonLabel className="capacity-popup-label">
                            {option.OPTION_TITLE}
                          </IonLabel>
                        </IonItem>
                      </IonRadioGroup>
                      {index < capacityTypeData.CONTENT_VALUE.length - 1 &&
                      isMobile ? (
                        <IonItemDivider />
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <React.Fragment key={index} />
                  )
                )}
              </IonCol>
            </IonRow>
          </div>
        </CustomModal>
      ) : (
        <CustomModalWeb {...Preferences_CapacityTypeModalProps}>
          <IonRow className="ion-margin">
            <IonCol class="preference-content">
              {capacityTypeData.CONTENT_TITLE}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className={isMobile ? "" : "radio-group"}>
              {capacityTypeData.CONTENT_VALUE.map((option: any, index: any) =>
                PreferenceViewValidation("CAPACITY_TYPE") ? (
                  <div key={option.OPTION_TITLE}>
                    <IonRadioGroup
                      onIonChange={handleChange}
                      name={option.OPTION_VALUE}
                      value={"test"}
                    >
                      <IonItem key={option.OPTION_TITLE}>
                        <IonRadio
                          value={option.OPTION_VALUE}
                          name={capacityTypeData.API_KEY}
                          class="radiobutton"
                          mode="md"
                        />
                        <IonLabel className="capacity-popup-label">
                          {option.OPTION_TITLE}
                        </IonLabel>
                      </IonItem>
                    </IonRadioGroup>
                  </div>
                ) : (
                  <React.Fragment key={index} />
                )
              )}
            </IonCol>
          </IonRow>
        </CustomModalWeb>
      )}
    </>
  );
};
